/* eslint-disable react/prop-types */
import { useEffect, useMemo, useRef, useState } from "react";
import { connectToolbarDesktop } from "./ToolbarDesktop.connect";
import TimeSettingsDesktop from "./TimeSettingsDesktop/TimeSettingsDesktop";
import LeftSideMenu from "../LeftSideMenu/LeftSideMenu";
import RightSideMenu from "../RightSideMenu/RightSideMenu";
import { CONFIG } from "../../config/api.config";
import SVG_DepositIcon from "../../assets/images/svgs/Deposit.svg?react";
import SVG_WithdrawIcon from "../../assets/images/svgs/Withdraw.svg?react";
import SVG_SearchIcon from "../../assets/images/svgs/search_light.svg?react";
import SVG_SettingIcon from "../../assets/images/svgs/settings_white.svg?react";
import SVG_BacktIcon from "../../assets/images/svgs/chevronleft.svg?react";
// import SVG_SpadeIcon from "../../assets/images/svgs/spade.svg?react";
// import SVG_CardDeckIcon from "../../assets/images/svgs/cards-deck.svg?react";
// import SVG_RocketIcon from "../../assets/images/svgs/rocket.svg?react";
// import SVG_DiceIcon from "../../assets/images/svgs/dice.svg?react";
// import SVG_FishIcon from "../../assets/images/svgs/fish.svg?react";
import SVG_LoginIcon from "../../assets/images/svgs/login.svg?react";
import SVG_AddUserIcon from "../../assets/images/svgs/addUser.svg?react";
// import SVG_UserIcon from "../../assets/images/svgs/user.svg?react";
import SVG_CloseIcon from "../../assets/images/svgs/close-white.svg?react";
import SVG_MenuIcon from "../../assets/images/svgs/menu.svg?react";
import SVG_NotiCloseIcon from "../../assets/images/svgs/notificationClose.svg?react";
import SVG_BellIcon from "../../assets/images/svgs/bell.svg?react";
// import SVG_SportsBook from "../../assets/images/svgs/sportsBook.svg?react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { pagesInfoMapper } from "../../helpers/pagesinfoMapper.helper";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import SearchDesktop from "../SearchDesktop/SearchDesktop";
// import httpAuth from "../../services/httpAuth";
// import moment from "moment";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";
import {
  AuraSVG,
  AvitorSVG,
  CricketSVG,
  ElectionSVG,
  FishingSVG,
  FootballSVG,
  GreySVG,
  HomeSVG,
  HorseSVG,
  IplSVG,
  LiveCasinoSVG,
  SlotSVG,
  TennisSVG,
  UserSVG,
} from "../SvgImage/SvgImage";

const ToolbarDesktop = ({
  balance,
  messages,
  notifications,
  user,
  contentScrolled = false,
  setStyle = () => null,
  actions,
  // search = false,
  // noSearch = true,
  menu,
  auth,
  // B2C,
  // animatedText,
  searchValue,
  logo,
  language,
  isNotificationOpen,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const storedTime = localStorage.getItem("lastVisitTime");

  const [openSearch, setOpenSearch] = useState(false);
  const [leftSideMenuOpen, setLeftSideMenuOpen] = useState(false);
  const [rightSideMenuOpen, setRightSideMenuOpen] = useState(false);
  const [pageInfo, setPageInfo] = useState(null);
  const [lastLoggedIn, setLastLoggedIn] = useState("");

  let userDetail = localStorage?.getItem(USER_DATA);
  let userData = userDetail && JSON.parse(userDetail);

  useEffect(() => {
    if (storedTime) {
      setLastLoggedIn(storedTime);
    } else {
      const currentTime = new Date()
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(",", "");

      localStorage.setItem("lastVisitTime", currentTime);
      setLastLoggedIn(currentTime);
    }
  }, [storedTime]);

  useEffect(() => {
    const segmant = location.pathname.split("/");
    const required = pagesInfoMapper[segmant[1]];
    if (required) {
      if (
        segmant[1] == "sports-page" ||
        segmant[1] == "competition-detail-page"
      ) {
        setPageInfo({
          ...required,
          headerName: decodeURIComponent(segmant[2]),
        });
      } else if (segmant[1] == "casino-lobby") {
        setPageInfo({
          ...required,
          headerName: setCasinoLobbyHeaderName(segmant),
        });
      } else {
        setPageInfo(required);
      }
    } else {
      setPageInfo(pagesInfoMapper["default-page"]);
    }
  }, [location]);

  const setCasinoLobbyHeaderName = (segmant) => {
    let correctSegment = segmant.map((item) =>
      decodeURIComponent(item).replace(/-/g, " ")
    );
    if (segmant[2]?.toLowerCase() == "provider") {
      return correctSegment.slice(2, -1).join("/");
    }
    return correctSegment.slice(2).join("/");
  };

  const refScroll = useRef(null);

  const hableSearchChange = (value) => {
    actions.setSearchValues(value);
  };

  useEffect(() => {
    actions.setSearchValue(searchValue);
  }, [actions, searchValue]);

  useEffect(() => {
    if (contentScrolled) {
      setStyle({
        transform: `translate3d(0px, -${refScroll.current.clientHeight}px, 0px)`,
        height: "50px",
      });
    } else {
      setStyle({
        transform: "none",
      });
    }
  }, [contentScrolled, setStyle]);

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  const getMenu = (data) => {
    actions
      .requestRacingPageData(data)
      .catch((e) => console.log("menu error = ", e));
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        actions.setIsNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  const LanguageChange = () => {
    return (
      <button
        className="relative overflow-hidden  hidden lg:flex items-center ml-1 text-text_color_primary2 justify-center text-xs py-2.5 px-2 rounded-full bg-bg_color_secondary border border-border_color_primary"
        type="button"
        style={{ color: "#fff" }}
        onClick={() => {
          actions.setIsLangauage(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-4 h-4 mr-0.5"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
          <path d="M3.6 9h16.8"></path>
          <path d="M3.6 15h16.8"></path>
          <path d="M11.5 3a17 17 0 0 0 0 18"></path>
          <path d="M12.5 3a17 17 0 0 1 0 18"></path>
        </svg>
        {language?.toUpperCase()}
        <svg
          fill="currentColor"
          width="16"
          height="16"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 330 330"
          className="w-3 h-3 ml-2"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              id="XMLID_225_"
              d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
            ></path>
          </g>
        </svg>
      </button>
    );
  };

  const memoizedNotification = useMemo(() => {
    return (
      <div className=" w-max h-max relative font-lato" ref={dropdownRef}>
        <div
          className="bg-none border-none shadow-none px-1 mr-2 cursor-pointer transition-all ease-in-out duration-200 active:scale-105"
          style={{ position: "relative" }}
          onClick={() => actions.setIsNotificationOpen(!isNotificationOpen)}
        >
          <SVG_BellIcon stroke="#ef8402" />
          <div
            className="absolute top-[-8px] right-[-1px] text-text_color_loginButtonTextColor bg-bg_color_LoginBtnBgColor font-lato font-bold text-[12px] rounded-[50%] w-[18px] h-[18px] flex items-center justify-center "
            style={{
              backgroundImage:
                "linear-gradient(95deg,#ef8402 -8.6%,#ef8402 110.45%)",
              color: "#fff",
            }}
          >
            <span> 0</span>
          </div>
        </div>
        {isNotificationOpen && (
          <div
            className=" absolute popUpOpenAnimation origin-top-right right-[10%] md:top-[125%] px-1 md:px-1.5 md:py-1.5 sm:px-[3px] py-1  flex flex-col bg-bg_color_primary rounded-[5px] shadow-notificationBoxShadow text-text_color_primary1  overflow-y-auto max-h-[300px]  w-[220px] sm:w-[350px]"
            style={{
              zIndex: 1000,
              top: "100%",
              // width: 350,
              // backgroundColor: "#fff",
            }}
          >
            <div className=" w-full py-1 flex items-center  justify-between ">
              <span className=" text-white text-md md:text-base font-bold">
                Notifications
              </span>
              <span>
                <div
                  className="transition-all active:scale-[103%] ease-in-out duration-200 hover:scale-105 }"
                  onClick={() =>
                    actions.setIsNotificationOpen(!isNotificationOpen)
                  }
                >
                  <SVG_NotiCloseIcon />
                </div>
              </span>
            </div>
            <div className=" font-lato items-center py-2 font-medium  justify-center w-full flex flex-col">
              <span className=" animate-shake">🔔</span>
              <span>All caught up! No notifications at the moment.</span>
            </div>
          </div>
        )}
      </div>
    );
  }, [isNotificationOpen]);

  const memoizedRightMenu = useMemo(() => {
    return (
      <>
        {auth ? (
          <div className=" flex justify-between items-center gap-x-1 h-max lg:hidden">
            {memoizedNotification}
            {CONFIG.showDeposit && (
              <button
                type="button"
                className=" leading-normal  transition duration-150 
                ease-in-out overflow-hidden relative active:scale-95 
                hidden xxs:flex items-center 
                h-fit justify-center bg-bg_Quaternary2 rounded-md px-1.5 py-2 sm:px-4 sm:py-1.5 
                text-white text-sm   text-center  cursor-pointer"
                onClick={() => {
                  navigate("/deposit");
                }}
              >
                <span className="font-semibold flex flex-row font-lato md:font-normal sm:text-base xs:text-sm">
                  <span>Deposit</span>
                </span>
                <span className="shimmer"></span>
              </button>
            )}
            <button
              title="Balance"
              className={`leading-normal text-black lg:text-white relative overflow-hidden  transition duration-150 ease-in-out rounded-md lg:rounded-full   pl-3 md-bg_Secondary lg:bg-bg_Secondary flex items-center justify-center pr-1 py-2 xs:py-2 sm:py-2  gap-1 shadow-[0_8px_30px_rgb(0,0,0,0.12)]  cursor-pointer`}
              type="button"
              onClick={() => {
                setRightSideMenuOpen(true);
              }}
            >
              <span className="text-xs sm:text-base font-semibold bg-transparent">
                ₹
                {balance && balance.balance
                  ? getCurrencyFormat(balance.balance)
                  : 0}
              </span>
              <UserSVG />
            </button>
          </div>
        ) : (
          <>
            <div
              className={`w-max  hidden lg:flex items-center justify-center gap-1 lg:rounded-full -lg:rounded`}
            >
              <button
                id="loginButton"
                className={`hidden lg:flex  rounded-full border border-quaternary hover:opacity-100 w-max font-extrabold items-center justify-center py-2 bg-bg_Secondary lg:relative lg:gap-1 lg:pr-4 lg:pl-3 -lg:px-4`}
                onClick={() => {
                  actions.setLoginNew(true);
                }}
              >
                <span
                  className={`w-max  text-text_LoginTextColor hidden lg:block`}
                >
                  <SVG_LoginIcon />
                </span>
                <span className=" text-x lg:text-xxs text-text_LoginHeadercolor lg:text-text_LoginTextColor font-normal font-lato md:font-semibold lg:text-xs md:text-sm xs:text-xs -lg:font-[800]">
                  Log In
                </span>
              </button>

              {CONFIG.showSignupOption && (
                <button
                  className="flex rounded-full lg:border border-secondary gap-1 hover:opacity-100 w-max font-extrabold items-center justify-center lg:pr-4 lg:pl-3 py-2 -lg:px-4 bg-bg_Quaternary"
                  onClick={() => {
                    actions.setLoginNew(true);
                    actions.setTab(2);
                  }}
                >
                  <span className=" w-max  hidden lg:block">
                    <SVG_AddUserIcon stroke="#fff"/>
                  </span>
                  <span className=" text-x lg:text-xxs  text-text_Primary  md:text-text_Ternary font-lato md:font-semibold lg:text-xs md:text-sm  xs:text-xs">
                    Sign Up
                  </span>
                </button>
              )}
              <LanguageChange />
            </div>
            <div className="lg:hidden  w-max flex items-center gap-1 justify-center  rounded">
              <button
                onClick={() => {
                  actions.setLoginNew(true);
                }}
                id="loginButton"
                className="flex  hover:opacity-100 w-max font-extrabold items-center justify-center  bg-bg_color_SignUpBtnBgColor rounded-md px-2.5 py-1.5"
              >
                <span className=" text-x text-text_color_signUpTextColor font-lato md:font-semibold xs:text-xs  md:text-sm font-[800]">
                  Log In
                </span>
              </button>
              <button
                onClick={() => {
                  actions.setLoginNew(true);
                  actions.setTab(2);
                }}
                title="signUpButton"
                id="signUpButton"
                className="flex hover:opacity-100 w-max font-extrabold items-center justify-center   bg-bg_color_LoginBtnBgColor rounded-md px-2.5 py-1.5 
              relative overflow-hidden
              "
              >
                <span className=" text-x   text-text_color_loginTextColor  font-lato md:font-semibold xs:text-xs  md:text-sm font-[800]">
                  Sign Up
                </span>
                <span className="shimmer" />
              </button>
            </div>
          </>
        )}
      </>
    );
  }, [auth, balance, isNotificationOpen]);

  return (
    <>
      <div ref={refScroll}>
        {messages && messages.length > 0 && notifications !== false ? (
          <div className="ion-toolbar__wrapper-desktop notification__desktop">
            <div className="notification__container">
              <div className="notification__container__marquee-desktop">
                {messages
                  .filter((e) => !e.Type || e.Type == "T")
                  .map((message) => (
                    <div
                      key={message.id}
                      className="notification__container__message-desktop"
                    >
                      {message.text}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div
        id="header"
        title="header"
        className={`${pageInfo?.headerClass} w-full z-[100]`}
        // className={`fixed top-0 w-full z-[100]`}
        style={{ zIndex: "1000" }}
      >
        <header>
          <div className="flex flex-col">
            <div className=" flex flex-col shadow-lg autoAnimate">
              <div
                id="header_body"
                className={`w-full bg-headerBg h-[54px] lg:h-[72px] pr-[4px] md:px-4 flex items-center justify-between gap-1 ${
                  openSearch ? " py-[11px] " : ""
                }  relative `}
              >
                <div
                  id="logoContainer"
                  className={`logo flex w-full  ${
                    openSearch ? "justify-start" : " h-full md:w-fit"
                  } `}
                >
                  <div className=" flex items-center w-[40px] md:w-fit justify-center lg:hidden ">
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none h-full flex items-center justify-center active:scale-150  w-[100%] shadow-none px-1 cursor-pointer"
                      type="button"
                      onClick={() => {
                        setLeftSideMenuOpen(true);
                      }}
                    >
                      <span>
                        <SVG_MenuIcon />
                      </span>
                    </button>
                  </div>

                  {openSearch && (
                    <div className=" transition-all ease-in-out duration-300 origin-top-right  relative ml-2 w-full popUpOpenAnimation">
                      <input
                        id="searchEventsMobile"
                        className="relative z-1 bg-transparent text-text_Quaternary outline-none border-none focus-none w-full pr-6 font-lato"
                        autoComplete="off"
                        type="text"
                        value={searchValue}
                        onChange={(e) => hableSearchChange(e.target.value)}
                      />
                      {!searchValue && (
                        <label
                          htmlFor="searchEventsMobile"
                          className=" absolute  font-lato font-light ml-[2px] z-0 top-0 left-0 right-0 bottom-0 text-xs xs:text-base text-text_Quaternary flex items-center justify-start w-full"
                        >
                          Search Events(At least 3 letters)...
                        </label>
                      )}
                      <button
                        className=" pl-4 flex items-center justify-center opacity-95 hover:opacity:100 absolute top-1/2 right-1 active:scale-150 -translate-y-1/2"
                        aria-label="Cancel Search"
                        onClick={() => {
                          setOpenSearch(!openSearch);
                        }}
                      >
                        <SVG_CloseIcon fill={"#fff"} />
                      </button>
                      <SearchDesktop
                        closeOnMobile={() => {
                          setOpenSearch(false);
                        }}
                      />
                    </div>
                  )}

                  {!openSearch && (
                    <div className="flex items-center">
                      <div
                        className="cursor-pointer "
                        onClick={() => {
                          navigate("/");
                        }}
                      >
                        <img
                          src={logo}
                          alt="logo"
                          className="hidden sm:block"
                          style={{
                            maxHeight: "34px",
                          }}
                        />
                        <img
                          src={logo}
                          className="sm:hidden"
                          alt="logo"
                          style={{
                            maxHeight: "40px",
                            maxWidth: "96px",
                            // maxWidth: "140px",
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {!openSearch && (
                  <>
                    <div
                      id="searchBox"
                      className="text-text_Quaternary relative hidden max-w-96 font-lato lg:block flex-grow"
                    >
                      <div className=" relative w-full max-w-[450px]">
                        <input
                          className="border-1 peer w-full  appearance-none text-xs pl-9 py-2.5 border border-border_color_primary  rounded-full md:text-[14px]  bg-bg_Quaternary  text-text_Ternary "
                          placeholder="Search Events(At least 3 letters)..."
                          type="text"
                          value={searchValue}
                          onChange={(e) => hableSearchChange(e.target.value)}
                        />
                        <SVG_SearchIcon />
                      </div>
                      {searchValue && (
                        <SearchDesktop closeOnMobile={() => {}} />
                      )}
                    </div>
                    <TimeSettingsDesktop />

                    {auth && (
                      <>
                        <div
                          id="loginName"
                          className=" text-text_Quaternary text-[10px] lg:text-[12px] xl:flex flex-col px-1.5 hidden"
                        >
                          <div className="flex gap-0.5 text-white/80  text-nowrap whitespace-nowrap">
                            Login as
                            <span className="font-medium text-text_Quaternary">
                              {user && user?.name && user?.name}
                            </span>
                          </div>
                          <div className="flex  gap-0.5 text-white/80  text-nowrap whitespace-nowrap">
                            Last logged in
                            <span className="font-medium text-text_Quaternary">
                              {lastLoggedIn}
                            </span>
                          </div>
                        </div>

                        <div
                          id="loginName"
                          className=" text-text_Quaternary text-[10px] lg:text-[12px] lg:flex flex-col px-1.5 hidden"
                        >
                          <div className="flex gap-0.5 text-white/80  xl:text-nowrap whitespace-nowrap">
                            Available balance:
                            <span className="font-medium text-text_Quaternary">
                              ₹{" "}
                              {balance && balance.balance
                                ? getCurrencyFormat(balance.balance)
                                : 0}
                            </span>
                          </div>
                        </div>

                        <div
                          id="deposit_withdraw_btn"
                          className=" hidden lg:flex items-center justify-center gap-1"
                        >
                          {CONFIG.showDeposit && (
                            <button
                              className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none shadow-none cursor-pointer"
                              type="button"
                              onClick={() => {
                                navigate("/deposit");
                              }}
                            >
                              <span className="text-white capitalize border  flex rounded px-3 py-1  flex-col text-[10px]  hover:opacity-100 w-max font-semibold items-center justify-center  bg-bg_HeaderDepositBtnBgColor border-depositBtn ">
                                <SVG_DepositIcon />
                                deposit
                              </span>
                            </button>
                          )}
                          {CONFIG.showWithdrawal && (
                            <button
                              className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none shadow-none  cursor-pointer"
                              type="button"
                              onClick={() => {
                                navigate("/withdraw");
                              }}
                            >
                              <span className="text-white capitalize border  flex rounded px-3 py-1  flex-col text-[10px]  hover:opacity-100 w-max font-semibold items-center justify-center  bg-bg_HeaderWithdrawBtnBgColor border-withDrawBtn ">
                                <SVG_WithdrawIcon />
                                withdraw
                              </span>
                            </button>
                          )}
                        </div>

                        <div className=" w-max hidden items-center justify-center gap-1 rounded-full  lg:flex">
                          {memoizedNotification}

                          <button
                            className="relative flex rounded-full gap-1 border border-quaternary hover:opacity-100 w-max font-extrabold items-center justify-center pr-4 pl-3 py-2 bg-bg_Secondary"
                            onClick={() => {
                              setRightSideMenuOpen(true);
                            }}
                          >
                            <span className=" w-max text-text_LoginTextColor flex gap-1">
                              <SVG_SettingIcon />
                            </span>
                            <span className=" text-xxs text-text_LoginTextColor  md:text-text_LoginTextColor  font-normal font-lato md:font-semibold md:text-xs xs:text-xs ">
                              Account
                            </span>
                          </button>

                          <LanguageChange />
                        </div>
                      </>
                    )}

                    <div className=" w-max flex items-center justify-center">
                      <div
                        id="mobileSearchIcon"
                        className=" lg:hidden mr-[2px] flex items-center justify-center"
                        onClick={() => {
                          setOpenSearch(!openSearch);
                        }}
                      >
                        <span className="bg-none border-none shadow-none px-1">
                          <SVG_SearchIcon
                            width={20}
                            height={20}
                            fill={"#ef8402"}
                            className={""}
                          />
                        </span>
                      </div>

                      {memoizedRightMenu}
                    </div>
                  </>
                )}
              </div>

              <div className="">
                <div className="flex w-full overflow-x-auto no-scrollbar     bg-bg_Quaternary p-1.5 items-start md:items-center md:justify-center ">
                  <Link to={"/"}>
                    <button
                      className={`text-xs cursor-pointer flex gap-1 uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu   ${
                        location.pathname === "/"
                          ? "text-text_brand_primary  opacity-100"
                          : " opacity-70"
                      }`}
                      // className="text-xs cursor-pointer uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenuHover  md:hidden "
                    >
                      <span>
                        <HomeSVG height={16} width={16} />
                      </span>
                      <span className="font font-lato text-[12px]">Home</span>
                    </button>
                  </Link>
                  <Link
                    title="IPL"
                    className="cursor-pointer uppercase min-h-[28px] min-w-max text-nowrap  font-semibold whitespace-nowrap   flex items-center justify-center   rounded-full mr-1 bg-bg_color_iplMenuBoxBg text-text_color_primary2 pl-1 pr-3 gap-x-1"
                    // href="/cricket/competitions/Indian-Premier-League/4/101480"
                  >
                    <div className=" flex items-center justify-center size-5 bg-[#f3f4f6] rounded-full">
                      <IplSVG height={16} width={16} />
                    </div>
                    <span className="font font-lato text-[12px]">IPL</span>
                  </Link>

                  <Link to={"/sports-page/Sportsbook/0"}>
                    <button
                      className={`text-xs cursor-pointer uppercase  opacity-70 active:border-primary text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu`}
                      to={"/sports-page/Sportsbook/0"}
                      onClick={() => {
                        actions.setIsNavigationID("0");
                        actions.setIsNavigationName("Sportsbook");
                      }}
                    >
                      <span className="flex w-full items-center h-full gap-3">
                        <span className=" flex flex-row items-center justify-center">
                          <span>
                            <HomeSVG height={16} width={16} />
                          </span>
                          <span className="font font-lato text-[12px] ml-[4px]">
                            SPORTS
                          </span>
                        </span>
                      </span>
                    </button>
                  </Link>

                  {isSportAvailable("4") && (
                    <Link to={"/sports-page/Cricket/4"}>
                      <button
                        className={`text-xs flex gap-1 cursor-pointer uppercase   active:text-text_brand_primary text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  ${
                          ["sports-page/Cricket", "event-page/4"].some((path) =>
                            location.pathname.includes(path)
                          )
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={() => {
                          actions.setIsNavigationID("4");
                          actions.setIsNavigationName("Cricket");
                        }}
                      >
                        <CricketSVG height={16} width={16} />
                        <span className="font font-lato text-[12px]">
                          Cricket
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("1") && (
                    <Link to={"/sports-page/football/1"}>
                      <button
                        className={`text-xs cursor-pointer uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  flex gap-1 ${
                          ["sports-page/football", "event-page/1"].some(
                            (path) => location.pathname.includes(path)
                          )
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={() => {
                          actions.setIsNavigationID("1");
                          actions.setIsNavigationName("Football");
                        }}
                      >
                        <FootballSVG height={16} width={16} />
                        <span className="font font-lato text-[12px]">
                          Football
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("2378961") && (
                    <Link to={"/election"}>
                      <button
                        className={`text-xs cursor-pointer uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  flex gap-1 ${
                          location.pathname.includes("election")
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                      >
                        <ElectionSVG />
                        <span className="font font-lato text-[12px]">
                          Election
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("2") && (
                    <Link to={"/sports-page/tennis/2"}>
                      <button
                        className={`text-xs cursor-pointer uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  flex gap-1 ${
                          ["sports-page/tennis", "event-page/2"].some((path) =>
                            location.pathname.includes(path)
                          )
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={() => {
                          actions.setIsNavigationID("2");
                          actions.setIsNavigationName("Tennis");
                        }}
                      >
                        <TennisSVG height={16} width={16} />
                        <span className="font font-lato text-[12px]">
                          Tennis
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("7") && (
                    <Link to={"/horse-racing"}>
                      <button
                        className={`text-xs cursor-pointer uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  flex gap-1 ${
                          location.pathname.includes("horse-racing")
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={() => {
                          const horseRacing = { sport_id: "7" };

                          getMenu(horseRacing);
                          actions.setIsNavigationID("7");
                          actions.setIsNavigationName("Horse Racing");
                        }}
                      >
                        <HorseSVG height={16} width={16} />
                        <span className="font font-lato text-[12px]">
                          Horse Racing
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("4339") && (
                    <Link to={"/greyhound-racing"}>
                      <button
                        className={`text-xs cursor-pointer uppercase  active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold   w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  flex gap-1 ${
                          location.pathname.includes("greyhound-racing")
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={() => {
                          const horseRacing = { sport_id: "4339" };

                          getMenu(horseRacing);
                          actions.setIsNavigationID("4339");
                          actions.setIsNavigationName("Greyhound Racing");
                        }}
                      >
                        <GreySVG height={16} width={16} />
                        <span className="font font-lato text-[12px]">
                          GreyHound Racing
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("QT") && (
                    <Link to={userData?.is_demo ? "#" : "/livegames/aura/FAWK"}>
                      <button
                        className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu   ${
                          location.pathname.includes("/livegames/aura/FAWK")
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={() => {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                        }}
                      >
                        <span className="flex w-full items-center h-full gap-3">
                          <span className=" flex flex-row items-center justify-center">
                            {/* <span >
                              <SVG_SpadeIcon
                                width={15}
                                height={15}
                                fill={"var(--color-secondary)"}
                              />
                            </span> */}
                            <AuraSVG height={16} width={16} />
                            <span className="font font-lato text-[12px] ml-[4px]">
                              Aura
                            </span>
                          </span>
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("QT") && (
                    <Link to={"#"}>
                      <button
                        className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu   ${
                          location.pathname.includes("/casino-lobby/casino")
                            ? "text-text_brand_primary opacity-100"
                            : "opacity-70"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (auth) {
                            if (userData?.is_demo) {
                              toastr.error(
                                "",
                                "Please login from your read ID."
                              );
                              return;
                            }
                            navigate("/casino-lobby/casino");
                            if (
                              !location.pathname.includes(
                                "/casino-lobby/casino"
                              )
                            ) {
                              actions.openSlotCasinoPopUp();
                            }
                          } else {
                            actions.setLoginNew(true);
                            actions.setLoginNavigationData({
                              page: "casino-lobby/casino",
                              ids: [],
                            });
                          }
                        }}
                      >
                        <span className="flex w-full items-center h-full gap-3">
                          <span className=" flex flex-row items-center justify-center">
                            {/* <span className="md:hidden">
                              <SVG_CardDeckIcon
                                width={15}
                                height={15}
                                fill={"var(--color-secondary)"}
                              />
                            </span> */}
                            <LiveCasinoSVG height={16} width={16} />
                            <span className="font font-lato text-[12px] ml-[4px]">
                              Live Casino
                            </span>
                          </span>
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("QT") && (
                    <>
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu   ${
                            location.pathname.includes(
                              "/casino-live/SPB-aviator/SPB"
                            )
                              ? "text-text_brand_primary opacity-100"
                              : "opacity-70"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID."
                                );
                                return;
                              }
                              navigate("/casino-live/SPB-aviator/SPB");
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-live/SPB-aviator/SPB",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              {/* <span className="md:hidden">
                                <SVG_RocketIcon width={16} height={16} />
                              </span> */}
                              <AvitorSVG height={16} width={16} />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Aviator
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                      {/* <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu   ${
                            location.pathname.includes("/casino-lobby/casino")
                              ?  "text-text_brand_primary opacity-100"
                              : "opacity-70"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID."
                                );
                                return;
                              }
                              navigate("/casino-lobby/casino");
                              if (
                                !location.pathname.includes(
                                  "/casino-lobby/casino"
                                )
                              ) {
                                actions.openSlotCasinoPopUp();
                              }
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/casino",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              <span className="md:hidden">
                                <SVG_CardDeckIcon width={16} height={16} />
                              </span>
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Casino
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link> */}
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  ${
                            location.pathname === "/casino-lobby/slot-games"
                              ? "text-text_brand_primary opacity-100"
                              : "opacity-70"
                          } `}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID."
                                );
                                return;
                              }

                              navigate("/casino-lobby/slot-games");
                              if (
                                !location.pathname.includes(
                                  "/casino-lobby/slot-games"
                                )
                              ) {
                                actions.openSlotCasinoPopUp();
                              }
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/slot-games",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              {/* <span className="md:hidden"> */}
                              <SlotSVG height={16} width={16} />
                              {/* </span> */}
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Slots
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  ${
                            location.pathname ===
                            "/casino-lobby/slot-games/Rubyplay"
                              ? "text-text_brand_primary opacity-100"
                              : "opacity-70"
                          } `}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID."
                                );
                                return;
                              }
                              navigate("/casino-lobby/slot-games/Rubyplay");
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/slot-games/Rubyplay",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              {/* <span className="md:hidden">
                                <SVG_RocketIcon width={16} height={16} />
                              </span> */}
                              <AvitorSVG height={16} width={16} />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Rubyplay-games
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase   active:border-primary rounded-full text-nowrap whitespace-nowrap font-semibold    w-max px-1.5  py-1  text-text_HeaderDeskNavMenu  ${
                            location.pathname ===
                            "/casino-lobby/slot-games/Turbo%20Games"
                              ? "text-text_brand_primary opacity-100"
                              : "opacity-70"
                          }  `}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID."
                                );
                                return;
                              }
                              navigate("/casino-lobby/slot-games/Turbo Games");
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/slot-games/Turbo Games",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              {/* <span className="md:hidden">
                                <SVG_FishIcon />
                              </span> */}
                              <FishingSVG />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Turbo-games
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>

            {!!pageInfo?.headerName && (
              <div className="lg:hidden flex flex-col  ">
                <div className="w-full h-[34px] pr-[4px] flex items-center justify-between gap-1  relative ">
                  <div className="app-bg flex-row w-full h-full flex cursor-pointer ">
                    <div className="w-[34px] h-full flex items-center justify-center   ">
                      <button
                        className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-8 rounded-sm h-6 flex ml-[4px] items-center justify-center bg-bg_Primary2 active:scale-150 cursor-pointer"
                        type="button"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        <SVG_BacktIcon width={20} height={20} />
                      </button>
                    </div>
                    <span className=" w-full h-full capitalize ml-[4px] flex items-center  text-text_Ternary  font-lato font-bold text-[16px] leading-5 ">
                      <span className="">
                        <span>{pageInfo?.headerName}</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {!!leftSideMenuOpen && (
            <LeftSideMenu
              setOpen={(val) => {
                setLeftSideMenuOpen(val);
              }}
            />
          )}

          {!!rightSideMenuOpen && (
            <RightSideMenu
              setOpen={(val) => {
                setRightSideMenuOpen(val);
              }}
            />
          )}
        </header>
      </div>
    </>
  );
};

export default connectToolbarDesktop()(ToolbarDesktop);
